// extracted by mini-css-extract-plugin
export default {"container":"PasswordForm_container__rXc+m","formLabel":"PasswordForm_formLabel__NadRU"};